/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Flex, Image, Spinner, Text, Toast } from 'pcln-design-system';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { submitChatMessages } from './submitChatMessages';
import { ScrollIntoView } from './ScrollIntoView';
import { History, SuccessOutline } from 'pcln-icons';
import { DialogLoading } from './DialogLoading';
import { ChatbotDataContext } from './context/ChatbotDataContext';
import { useDialogStylesContext } from './hooks/useDialogStylesContext';
import TryAgain from './components/TryAgain';
// import DebugComponent from './DebugComponent'
import { LoadMorePrompts, LoadMorePromptsWrapper, ToastWrapper } from './ChatContent.styles';
import { ChatMessagesList } from './ChatMessagesCollections';
import Loading from './components/Loading';
import { useStandaloneStyles } from './context/StandaloneStyleContext';
import { ChatInput } from './components/ChatInput/ChatInput';
import ClearHistory from './svgs/ClearHistory';
import { browserStorage } from './utils/browserStorage';
import { useChatMessagesContext } from './hooks/useChatMessagesContext';
import { useLoadingStateContext } from './hooks/useLoadingStateContext';
import { useChatUIContext } from './hooks/useChatUIContext';
import { useMarkerComponentMemo } from './hooks/useMarkerComponentMemo';
import { removePennyInitialMessageKeys } from './utils/removePennyInitialMessageKeys';
import PennyExpandableInput from './components/PennyExpandableInput';
import { resolveChatContentHeight, resolveChatContentStyle } from './utils/resolveChatContentVariables';
const GREETING_MESSAGE = "Hi, I'm Penny, your virtual travel assistant! How can I help you today?";
const TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_opener_logo_no_border_v1.1.svg';
/**
 * ChatMainContentSection
 * Main chat content
 * @public
 */
const ChatMainContentSection = ({
  retrievalLoading = false,
  visibilityChannel
}) => {
  var _a, _b;
  const {
    setLoadMoreMessages,
    submitChatMessagesPayload,
    handleMarkerResponse,
    fetchRequestOptions,
    markerComponents,
    errorMessage,
    setErrorMessage,
    setIsDisablingInputValue,
    fullStreamingTexts,
    setStreamingText,
    debugMode,
    discoveryCitySelected,
    pushPrompt,
    loadMoreMessages,
    isDisablingInput,
    accountLessAccessToken,
    accountLessTripsAccessPayload,
    setHotelPinOnMap,
    setiValues
  } = useContext(ChatbotDataContext);
  if (accountLessTripsAccessPayload) {
    submitChatMessagesPayload.accountLessTripsAccessPayload = accountLessTripsAccessPayload;
  }
  const memoMarkerComponents = useMarkerComponentMemo(markerComponents);
  const {
    chatMessages,
    setChatMessages
  } = useChatMessagesContext();
  const {
    openErrorComponent,
    setOpenErrorComponent
  } = useChatUIContext();
  const {
    isLoading,
    setLoadingStatus,
    loadingStatusMessages,
    setLoadingStatusMessage
  } = useLoadingStateContext();
  const contentRef = useRef(null);
  const messagesEndRef = useRef(null);
  const loadRef = useRef(null);
  const [lastMessage, setLastMessage] = useState('');
  const [showClearedHistory, setShowClearedHistory] = useState(false);
  const [isClearedHistoryActive, setIsClearedHistoryActive] = useState(false);
  const [currScrollHeight, setCurrScrollHeight] = useState(0);
  const {
    isSessionActive,
    hotelPayload,
    productId
  } = submitChatMessagesPayload;
  const isAudioPlaybackEnabledRef = useRef(false);
  const {
    isShowMoreListingCards = false
  } = hotelPayload !== null && hotelPayload !== void 0 ? hotelPayload : {};
  const {
    isExpandedInput
  } = setiValues !== null && setiValues !== void 0 ? setiValues : {};
  useEffect(() => {
    var _a;
    if (chatMessages) {
      // Find the last user message
      const lastContent = (_a = chatMessages.find(message => message.role === 'user')) === null || _a === void 0 ? void 0 : _a.content;
      if (lastContent) {
        setLastMessage(lastContent);
      }
    }
  }, [chatMessages.length]);
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
      });
    }
  }, []);
  const submitChatMessagesOptions = {
    setChatMessages,
    setStreamingText,
    setLoadingStatus,
    setErrorMessage,
    setIsDisablingInputValue,
    requestOptions: Object.assign(Object.assign({}, fetchRequestOptions), {
      headers: Object.assign(Object.assign({}, fetchRequestOptions === null || fetchRequestOptions === void 0 ? void 0 : fetchRequestOptions.headers), accountLessAccessToken ? {
        'account-less-access-token': accountLessAccessToken
      } : {})
    }),
    markerComponents,
    handleMarkerResponse,
    setLoadingStatusMessage
  };
  useEffect(() => {
    if (discoveryCitySelected || pushPrompt && !retrievalLoading) {
      const chatContent = discoveryCitySelected ? `Looking for hotels in ${discoveryCitySelected}` : pushPrompt;
      const chatMessage = {
        content: chatContent,
        date: new Date(),
        role: 'user'
      };
      const promptMessage = {
        content: chatContent,
        role: 'user'
      };
      const updatedChatMessages = [...chatMessages, chatMessage];
      //  set user's message
      setChatMessages(updatedChatMessages);
      // submit user's message to get response
      submitChatMessages(Object.assign(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          includeSpeech: isAudioPlaybackEnabledRef.current,
          prompts: [promptMessage]
        }),
        setOpenErrorComponent,
        chatMessages: updatedChatMessages
      }, submitChatMessagesOptions), {
        requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
          headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
            'account-less-access-token': accountLessAccessToken
          } : {})
        })
      }));
    }
  }, [discoveryCitySelected, pushPrompt]);
  useEffect(() => {
    const onScroll = () => {
      const scrollableDiv = contentRef.current;
      if (!scrollableDiv) {
        return;
      }
    };
    // eslint-disable-next-line no-unused-expressions
    if (contentRef.current) {
      contentRef.current.addEventListener('scroll', onScroll);
    }
    return () => {
      if (contentRef.current) {
        contentRef.current.removeEventListener('scroll', onScroll);
      }
    };
  }, []);
  useEffect(() => {
    var _a;
    const curHeight = (_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight;
    if (contentRef.current) {
      contentRef.current.scrollTop = curHeight - currScrollHeight;
    }
  }, [loadMoreMessages]);
  /**
   * Handles initial chat message submission based on session state and separator conditions.
   * Submits a separator message when a separator component or session initialization is present.
   * Submits initial prompts for new messages based on session state and retrieval loading status.
   * Includes speech functionality when voice is enabled and audio playback is allowed.
   */
  useEffect(() => {
    var _a;
    const submitChatMessagePayloadObj = Object.assign(Object.assign({
      setOpenErrorComponent,
      chatMessages
    }, submitChatMessagesOptions), {
      requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
        headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
          'account-less-access-token': accountLessAccessToken
        } : {})
      })
    });
    const isNewMessageWithSession = !browserStorage.isInitialMessageSubmitted() && !retrievalLoading || (chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages.length) === 1 && ((_a = chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages[0]) === null || _a === void 0 ? void 0 : _a.displayComponentName) === 'SESSION_INITIALIZED';
    /**
     * In penny-portal, we are submitting the initial message from the landing page.
     * Therefore, we don't want to submit a second time. This can be prevented by checking
     * if the productId is not -1.
     */
    if (isNewMessageWithSession && !pushPrompt && submitChatMessagesPayload.productId !== -1) {
      browserStorage.setInitialMessageSubmitted();
      submitChatMessages(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          // Hard code the initail
          prompts: [{
            role: 'user',
            content: 'Hello!!!'
          }]
        })
      }, submitChatMessagePayloadObj));
    }
  }, [retrievalLoading]);
  /**
   * When openErrorComponent fires (excepting initial load),
   * check to see if we can resubmit the last user msg.
   */
  const previousErrorState = useRef(openErrorComponent);
  useEffect(() => {
    var _a, _b;
    if (previousErrorState.current === openErrorComponent) {
      return;
    }
    previousErrorState.current = openErrorComponent;
    const curHeight = (_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight;
    setIsDisablingInputValue(openErrorComponent && !isDisablingInput);
    if ((chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages.length) > 0 && ((_b = chatMessages[chatMessages.length - 1]) === null || _b === void 0 ? void 0 : _b.role) === 'user') {
      const userMessage = chatMessages.reverse().find(message => message.role === 'user');
      submitChatMessages(Object.assign(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          prompts: [userMessage],
          includeSpeech: false
        }),
        setOpenErrorComponent,
        chatMessages
      }, submitChatMessagesOptions), {
        requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
          headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
            'account-less-access-token': accountLessAccessToken
          } : {})
        })
      }));
      if (contentRef.current) {
        contentRef.current.scrollTop = curHeight - currScrollHeight;
      }
    }
  }, [openErrorComponent]);
  useEffect(() => {
    if (!isLoading && isClearedHistoryActive && !showClearedHistory) {
      setShowClearedHistory(true);
      setTimeout(() => {
        setIsClearedHistoryActive(false);
        setShowClearedHistory(false);
      }, 1000);
    }
  }, [isClearedHistoryActive]);
  function submitChatMessageInMarkerComponent(msg, updatedChatMessage, headers) {
    // Based on quick actions, display marker component directly
    if (!msg.content && msg.displayComponentName) {
      setChatMessages([...chatMessages, msg]);
    } else {
      submitChatMessages(Object.assign(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          prompts: [msg]
        }),
        setOpenErrorComponent,
        // Local state control
        chatMessages: !Array.isArray(updatedChatMessage) || updatedChatMessage.length === 0 ? chatMessages : updatedChatMessage
      }, submitChatMessagesOptions), {
        requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
          headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), headers || {})
        })
      }));
    }
  }
  function handleClearHistory() {
    const submitChatMessagePayloadObj = Object.assign(Object.assign({
      setOpenErrorComponent,
      chatMessages: []
    }, submitChatMessagesOptions), {
      requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
        headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
          'account-less-access-token': accountLessAccessToken
        } : {})
      })
    });
    browserStorage.removeItem('pennysid');
    removePennyInitialMessageKeys();
    setChatMessages([]);
    setIsClearedHistoryActive(true);
    setHotelPinOnMap([]);
    submitChatMessages(Object.assign({
      submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
        prompts: [{
          role: 'user',
          content: 'Hello!!!'
        }]
      })
    }, submitChatMessagePayloadObj));
  }
  const dialogStyles = useDialogStylesContext();
  const standaloneStyles = useStandaloneStyles();
  const isDialogStylesEmpty = !(dialogStyles === null || dialogStyles === void 0 ? void 0 : dialogStyles.topLevelBoxStyle) || Object.keys(dialogStyles.topLevelBoxStyle).length === 0;
  const styles = resolveChatContentStyle({
    isDialogStylesEmpty,
    dialogStyles,
    standaloneStyles
  });
  const excludedFirstMessages = [GREETING_MESSAGE, '<SEPARATOR>'];
  const shouldLoadMorePrompts = productId === -1 || !loadMoreMessages && isSessionActive && !excludedFirstMessages.includes((_a = chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages[0]) === null || _a === void 0 ? void 0 : _a.content) && ((_b = chatMessages === null || chatMessages === void 0 ? void 0 : chatMessages[0]) === null || _b === void 0 ? void 0 : _b.displayComponentName) !== 'SESSION_INITIALIZED';
  return React.createElement(React.Fragment, null, retrievalLoading && isSessionActive ? React.createElement(Loading, null) : React.createElement(Box, Object.assign({}, Object.assign(Object.assign({}, styles.topLevelBoxStyle), {
    height: resolveChatContentHeight({
      isDialogStylesEmpty,
      isExpandedInput
    })
  }), {
    key: 'chat-dialog-transcript-container',
    ref: contentRef
  }), showClearedHistory ? React.createElement(ToastWrapper, {
    width: '300px'
  }, React.createElement(Toast, {
    color: 'success',
    colorScheme: 'successLight',
    icon: React.createElement(SuccessOutline, null),
    hideClose: true
  }, "Chat History Cleared")) : null, React.createElement(Flex, Object.assign({}, styles.contentFlexStyle), shouldLoadMorePrompts && React.createElement(LoadMorePromptsWrapper, {
    ref: loadRef
  }, React.createElement(LoadMorePrompts, {
    onClick: function () {
      var _a;
      setLoadMoreMessages(true);
      setCurrScrollHeight((_a = contentRef === null || contentRef === void 0 ? void 0 : contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight);
    }
  }, React.createElement(Button, {
    variation: 'link'
  }, ' ', React.createElement(History, {
    size: 20,
    mr: 2
  }), " View History")), React.createElement(LoadMorePrompts, {
    onClick: function () {
      handleClearHistory();
      setLoadMoreMessages(true);
    }
  }, React.createElement(Button, {
    variation: 'link',
    ml: 4
  }, ' ', React.createElement(ClearHistory, {
    size: 15
  }), " ", React.createElement(Text, {
    ml: 2
  }, " Clear History ")))), React.createElement(Flex, {
    justifyContent: 'center'
  }, loadMoreMessages ? React.createElement(Box, {
    mb: 4
  }, React.createElement(Spinner, {
    size: 40,
    color: 'purple'
  }, React.createElement(Image, {
    src: TRAVEL_BOT_LOGO,
    width: 28,
    alt: 'Penny chat avatar'
  }))) : null), React.createElement(ChatMessagesList, {
    messagesEndRef: messagesEndRef,
    isStandalone: isDialogStylesEmpty,
    chatMessages: chatMessages,
    markerComponents: memoMarkerComponents,
    isLoading: isLoading,
    debugMode: debugMode,
    setIsDisablingInputValue: setIsDisablingInputValue,
    setChatMessages: setChatMessages,
    submitMessages: submitChatMessageInMarkerComponent,
    submitChatMessageInMarkerComponent: submitChatMessageInMarkerComponent,
    isShowMoreListingCards: isShowMoreListingCards,
    submitQuickActionMessage: function (action) {
      const {
        chatContent,
        promptContent
      } = action;
      const promptMessage = {
        content: promptContent || chatContent,
        role: 'user'
      };
      const chatMessage = {
        content: chatContent,
        role: 'user'
      };
      const updatedChatMessages = [...chatMessages, chatMessage];
      // set user's message
      setChatMessages(updatedChatMessages);
      // submit user's message to get response
      submitChatMessages(Object.assign(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          prompts: [promptMessage]
        }),
        setOpenErrorComponent,
        // Local state control
        chatMessages: updatedChatMessages
      }, submitChatMessagesOptions), {
        requestOptions: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions), {
          headers: Object.assign(Object.assign({}, submitChatMessagesOptions.requestOptions.headers), accountLessAccessToken ? {
            'account-less-access-token': accountLessAccessToken
          } : {})
        })
      }));
    }
  }), errorMessage && openErrorComponent && React.createElement(ScrollIntoView, null, React.createElement(TryAgain, {
    lastMessage: lastMessage
  })), !isAudioPlaybackEnabledRef.current && isLoading &&
  // loading status for the bot only
  React.createElement(ScrollIntoView, null, React.createElement(DialogLoading, {
    streamingText: fullStreamingTexts,
    lastMessage: lastMessage,
    loadingStatusMessages: loadingStatusMessages
  }))), isDialogStylesEmpty ? React.createElement("div", {
    ref: messagesEndRef,
    style: {
      height: 0
    }
  }) : React.createElement(React.Fragment, null)), isExpandedInput ? React.createElement(PennyExpandableInput, {
    submitChatMessagesOptions: submitChatMessagesOptions,
    styles: styles
  }) : React.createElement(ChatInput, {
    showToolTip: isDialogStylesEmpty,
    styles: styles,
    isAudioPlaybackEnabledRef: isAudioPlaybackEnabledRef,
    submitChatMessagesOptions: submitChatMessagesOptions,
    visibilityChannel: visibilityChannel
  }));
};
export default React.memo(ChatMainContentSection);